module.exports = __webpack_public_path__ + "img/1.0e16be3e.svg";